import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { AlertsService } from '../../services/alerts.service';
import {
  GET_ALL_NOTIFICATION, GET_HEADER_NOTIFICATION,
  GETTING_STARTED_TIMEZONE_FIRST_URL, LOG_OUT_URL, LOGIN_STATUS, REDIRECT_NEWUI,
  READ_NOTIFICATION, REFER_FRIEND, RESEND_CONFIRMATION, SANDBOX_DOMAIN_NAME, UPDATE_ACTIVATION_EMAIL_ADDRESS,
  SWITCH_ACCOUNT, SUB_ACCOUNT_LIST, SUBACCOUNT_SWITCH, WARNING_MSG, GET_CLIENT_CONFIG,
  RCS_ACCOUNT_USAGE,
  WHATSAPP_ACCOUNT_USAGE
} from '../../../config';
import { ApiService } from '../../services/api.service';
import { MenuService } from '../../services/menu.service';
import { environment } from '../../../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EMAIL } from '../forms/form-validation';
import { Globals } from '../../services/globals';
import { HeaderService } from "../../services/header.service";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from '../../../services/auth.service';
import { DataService } from '../../services/data.service';
import { NotificationService } from "../../services/notification.service";
import { SubSink } from 'subsink';
import { ChannelRateLimitBannerDetailsDialogComponent, ChannelRateLimitBannerDetailsDialogData } from '../channel-rate-limit-banner-details-dialog/channel-rate-limit-banner-details-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

declare var require;

// declare let gaEmail;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit, OnDestroy {
  showHeader = false;
  hideHeaderRight = false;
  headerNotifications: any;
  twofa = '';
  emailExist = '';
  showActivation = false;
  activationMsg = "We've sent you a link to activate your account to the email address you've provided";
  activationEmail = '';
  activationEmailTemp = '';
  activationUpdateEmail = '';

  showEmail = false;
  showOnResend = false;
  alertText = '';
  alertTextP1: any;
  timeZoneSubscription: Subscription;
  headerSubscription: Subscription;
  alertSubscription: Subscription;
  refreshPageSub: Subscription;
  creditSubscription: Subscription;
  menuSubscription: Subscription;
  pepipost: boolean;
  email = '';
  notifications: any;
  unreadCount = 0;
  credits = 0;
  username = '';
  newUserFlag = true;
  parentUserName = '';
  updateEmailFrm: FormGroup;
  frmReferFriend: FormGroup;
  filtersForm: FormGroup;
  globalMode: string;
  productType = 'emailapi';

  dispGlobalMode: string;
  timzone: any;
  selectedTimeZone = '';
  popRef: NgbActiveModal;
  @ViewChild('referFriendPopup', { static: true }) referFriendPopup;
  @ViewChild('accountListSection', { static: true }) accountListSection;
  @ViewChild('verifyAccountPopup', { static: true }) verifyAccountPopup;
  @ViewChild('accountActicationExpiredLinkPopup', { static: true }) accountActicationExpiredLinkPopup;

  subAccountList: any;
  switchAccount = false;
  subaccountUsername: string;
  isDisabled = true;

  referFrndType = '';
  referFrndMsg = '';

  paid: any;
  back_to_falconide = false;

  isSubUser = false;   // role based access - subuser
  dataserviceSubscription: Subscription;

  newUIToggel = false;
  newUIDisplay: boolean;
  newUIv2Display: boolean;
  newUI: boolean;
  newUIClass: string;
  whatsapp_enabled_sttaus: any;
  deleteConfirmImg = '';

  subtitle = '';
  ssoPanel: boolean =false;
  
  /** When set, rate-limit banner is shown for WhatsApp or RCS routes. */
  demoMode = false;
  bannerData: any | null = null;

  private subs = new SubSink();
  knowMoreLink: string;

  constructor(private router: Router,
    private alertsService: AlertsService,
    private menuService: MenuService,
    private apiService: ApiService,
    private fb: FormBuilder,
    public globals: Globals,
    private headerService: HeaderService,
    private modalService: NgbModal,
    private authService: AuthService,
    private dataservice: DataService,
    private notification: NotificationService,
    private dialog: MatDialog,
  ) {

    this.updateHeaderRightVisibility(this.router.url);
    this.subs.sink = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects || event.url;
        this.updateHeaderRightVisibility(url);
      }
    });


    this.headerSubscription = headerService.showHeader$
      .subscribe(value => this.showHeader = value);

    this.headerSubscription = headerService.headerNotification$
      .subscribe(value => this.headerNotifications = value);

    this.subs.sink = this.headerService.logoSubtitle$.subscribe(value => this.subtitle = value);

    this.subs.sink = this.headerService.productType$.subscribe(value => {
      this.productType = value;
      this.getRateLimitBanner();
      // fetch MMLite status for WhatsApp if not fetched
      if (this.productType === 'conv_apps' && this.globals.shouldFetchMMLiteStatus) {
        this.fetchMMLiteStatus();
      }
    });


    this.deleteConfirmImg = this.globals.getDeleteConfirmImg();

    this.timeZoneSubscription = this.headerService.globaltimzone$
      .subscribe(text => this.timzone = text);

    this.alertSubscription = this.alertsService.p0Alert$
      .subscribe(text => this.alertText = text);

    this.alertSubscription = this.alertsService.p1Alert$
      .subscribe(text => this.alertTextP1 = text);


    this.refreshPageSub = this.alertsService.refreshPage$
      .subscribe(bool => this.refreshHeader());

    this.creditSubscription = this.menuService.credits$
      .subscribe(value => this.credits = value);

    this.menuSubscription = menuService.parentUserName$
      .subscribe(value => this.parentUserName = value);

    this.menuSubscription = menuService.pepipost$
      .subscribe(value => this.pepipost = value);

    this.dataserviceSubscription = dataservice.newUI$.subscribe(bool => this.newUI = bool);

    this.dataserviceSubscription = dataservice.newUIClass$.subscribe(string => this.newUIClass = string);
  }

  get channel(): 'rcs' | 'whatsapp' | '' {
    return this.globals.product_type === 'soip' ? 'rcs' : this.globals.product_type === 'conv_apps' ? 'whatsapp' : '';
  }

  ngOnInit() {



    this.dataservice.accountStatus$.subscribe(message => {
      if (message) {
        console.log(message['wa_enable'], '____________ wa nebale __________________')
        this.whatsapp_enabled_sttaus = message['wa_enable'];
        if (this.whatsapp_enabled_sttaus == 1) {

          this.apiService.whatapp_get(GET_CLIENT_CONFIG).subscribe(resp => {
            console.log(resp, '++++++ cleient config +++++++')
            if (resp && resp['data'] && resp['data']['utcs']) {
              this.globals.wa_timezone = resp['data']['utcs']
            }
          })
        }
      }
    });




    this.checkPageTabsAccess();  // for role base access - subuser login
    // console.log(this.globals.product_type,'______prod type ________')
    this.globalMode = this.globals.role;


    // Form validation for Email address on edit
    this.updateEmailFrm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern(EMAIL)]]
    });
    console.log("timzone", Intl.DateTimeFormat().resolvedOptions().timeZone);
    this.selectedTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.selectedTimeZone = this.selectedTimeZone.toLowerCase() === 'utc' ? 'US/Eastern' : this.selectedTimeZone;
    this.selectedTimeZone = this.selectedTimeZone === 'Asia/Kolkata' ? 'Asia/Calcutta' : this.selectedTimeZone;
    if (this.selectedTimeZone === '') {
      this.selectedTimeZone = 'Asia/Calcutta';
    }
    // make post call to save the data and redirect to domain page
    this.apiService.post(GETTING_STARTED_TIMEZONE_FIRST_URL, { 'timezone': this.selectedTimeZone })
      .subscribe(result => {
        if (result['status'] === 'success') {
        } else {
        }
      },
      );

    this.getCredit();
    this.getP0Notification();
    this.apiService.post(GET_ALL_NOTIFICATION)
      .subscribe((result) => {
        if (result['status'].toLowerCase() === 'success') {
          this.notifications = result['data']['notifications'];
          this.unreadCount = result['data']['unread_count'];
          this.ssoPanel = result['data']['sms_sso'] ? result['data']['sms_sso'] : false;
          // email for ther profile picture
          this.email = result['data']['emailid'];
          // gaEmail = result['data']['emailid'];
          this.username = result['data']['username'];
          this.globals.username = this.username;
          // hide switch to old panel for ew user
          this.newUserFlag = result['data']['is_new_user'];
          this.newUIDisplay = result['data']['newui'];
          this.newUIv2Display = result['data']['v2'];
          if (result['data']['accountEXLink'] == 1)
            this.open(this.accountActicationExpiredLinkPopup, 'delete-modal-width');

          // if(this.newUIDisplay === true) this.newUIToggel = true;
          this.timzone = result['data']['timzone'];
          this.headerService.showTimzone(this.timzone);
          if (typeof (result['data']['chk_mg_falconide_login']) !== 'undefined') {

            this.back_to_falconide = result['data']['chk_mg_falconide_login'];
          }
          else {
            this.back_to_falconide = result['data']['chk_mg'];
          }
          // (<any>window).ga('set', 'dimension1', this.username);
        } else {
        }
      }
      );

    this.isSwitchAccount();
  }

  getRateLimitBanner() {
    this.demoMode = false;
    if (!this.channel || this.channel === 'whatsapp') {
      this.bannerData = null;
      this.demoMode = false;
      this.headerService.setDemoMode(false);
      sessionStorage.removeItem('bannerData');
      return;
    }
    this.knowMoreLink = this.channel === 'rcs'
      ? 'https://netcorecloud.stoplight.io/docs/netcore-google-rcs-api-documentation/a81uep5v7was3-rcs-campaign-creation#faqs-on-ttl'
      : this.channel === 'whatsapp' ? 'https://netcorecloud.stoplight.io/docs/whatsappapidoc/5304c0fef85ed-whats-app-business-api#whatsapp-dashboard-login-url' : '';    
    const request =
      this.channel === 'rcs'
        ? this.apiService.get(RCS_ACCOUNT_USAGE)
        : this.channel === 'whatsapp' ? this.apiService.whatapp_get(WHATSAPP_ACCOUNT_USAGE) : null;

    request.pipe().subscribe((res) => {
        if (res && res['status'] === 'success') {
          this.bannerData = res.data;
          this.demoMode = !!(res.data?.has_demo ?? res.data?.has_demo_bots);
          this.headerService.setDemoMode(this.demoMode);
          sessionStorage.setItem('bannerData', JSON.stringify(res.data));
        } else {
          this.bannerData = null;
          this.demoMode = false;
          this.headerService.setDemoMode(false);
          sessionStorage.removeItem('bannerData');
        }
      }, error => {
        this.bannerData = null;
        this.demoMode = false;
        this.headerService.setDemoMode(false);
        sessionStorage.removeItem('bannerData');
      });
  }

  refreshHeader() {
    //this.ngOnInit();
  }

  notificationClick() {
    this.readAllNotification();
    this.router.navigate(['/notification']);
    return false;
  }

  redirectToPath(path) {
    this.router.navigate([path]);
    return false;
  }

  readAllNotification() {
    this.apiService.post(READ_NOTIFICATION)
      .subscribe((result) => {
        if (result['status'] === 'success') {
          this.unreadCount = 0;
        }
      },
      );
  }

  checkPageTabsAccess() {   // if login is subuser ( role base access )

    this.authService.isSubuser$.subscribe(bool => { this.isSubUser = bool; });
  }

  closeClick() {
    this.alertsService.hideP0Alert();
    this.alertsService.hideP1Alert();
    this.twofa = '';
    this.alertsService.alertPresent(false);
  }

  closeP1Click() {
    this.alertsService.alertPresent(false);
    this.alertsService.hideP1Alert();
  }

  closeActivationClick() {
    this.showActivation = false;
  }

  ngOnDestroy() {
    this.alertSubscription.unsubscribe();
    this.refreshPageSub.unsubscribe();
    this.creditSubscription.unsubscribe();

  }

  private updateHeaderRightVisibility(url: string) {
    const path = (url || '').split('?')[0].split('#')[0];
    this.hideHeaderRight = (path === '/product' || path.startsWith('/product/'));
  }

  goToAccessManagement() {
    // Ensure sidebar menu is visible when entering Settings
    this.menuService.showMenu();
    this.router.navigate(['/settings/manage-users-new']);
    return false;
  }

  goToAuditLogs() {
    this.router.navigate(['/billings/account-log']);
    return false;
  }
  redirectToProduct() {
    this.closeClick();
    this.closeP1Click();
    this.globals.product_type = '';
    this.router.navigate(['/product']);
  }

  logout() {
    // clear user account type on logout
    localStorage.removeItem('whatsappToken');
    this.apiService.cleanUpLocalStorageForSMS();
    window.location.href = `${environment.api_url}${LOG_OUT_URL}`;
    return false;
  }

  getCredit() {
    this.menuService.refreshCredits();
  }

  getP0Notification() {

    // this.headerService.headerNotification$.subscribe((result) => {
    // console.log(result);
    this.apiService.get(GET_HEADER_NOTIFICATION)
      .subscribe((result) => {
        if (result['status'] === 'success') {
          this.headerService.headerNotification()

          /*this.alertsService.showP0Alert(result['data']['p0']);
          // TODO: need to check p1 alerts , not displaying after disabling the error from ApiService
          this.alertsService.showP1Alert(result['data']['p1']);

          if( result['data']['p0'] !== '' || result['data']['p1']!=='' || result['data']['p2']['msg']!== '' )
            this.alertsService.alertPresent(true);*/

          if (result['data']['p2'] && result['data']['p2']['msg']) {
            this.showActivation = true;
            // this.activationMsg = result['data']['p2']['msg'];
            this.activationEmail = result['data']['p2']['emailid'];
          }
          if (result['data']['twofa'] !== '') {
            this.twofa = result['data']['twofa'];
            // this.alertsService.alertPresent(true);// added in service file hence commented
          }
        }
      },
      );
  }

  // api call to resend account activation link
  resendActivationLink() {
    this.apiService.get(RESEND_CONFIRMATION)
      .subscribe((result) => {
        if (result['status'] === 'success') {
          // this.showOnResend = true;
          this.showEmail = false;
          // this.showActivation = false;
          this.popRef.close();
          this.notification.showSuccess(result['message']);

        } else {
          this.notification.showError(result['error_info']['message']);
        }
      }, error => {
        this.notification.showWarning(WARNING_MSG);
      });

  }

  // function to cancel after activation resend link
  closeResendActivation() {
    this.showOnResend = false;
    this.showEmail = false;
    this.showActivation = true;
  }

  // show block to update email
  updateEmail() {
    this.activationEmailTemp = this.activationEmail;
    // this.activationEmail = '';
    // this.emailExist = '';
    this.showEmail = true;
    return false;
  }

  // function to save / update email address
  saveNewEmail(formdata) {
    this.apiService.get(UPDATE_ACTIVATION_EMAIL_ADDRESS + '?emailid=' + formdata.email)
      .subscribe((result) => {
        if (result['status'] === 'success') {
          this.showEmail = false;
          this.activationEmail = formdata.email;
          this.resendActivationLink();
          // this.notification.showSuccess(result['message']);
          this.showEmail = false;

        } else {
          this.showEmail = true;
          this.notification.showError(result['error_info']['message']);
        }
      }, error => {
        this.notification.showWarning(WARNING_MSG);
      });
  }

  cancelNewEmail() {
    this.activationEmail = this.activationEmailTemp;
    this.showEmail = false;
  }

  changeMode(mode) {
    this.globalMode = mode;
    this.globals.role = mode.toLowerCase();
    this.globals.globalDomain = this.globals.selected = this.globals.selected = mode.trim() === 'sandbox' ? SANDBOX_DOMAIN_NAME : 'all';
    // this.globals.globalDomain = mode;
    this.ngOnInit();
    this.globals.changeMode(mode, this.router.url);
  }

  openReferFriend() {
    this.referFrndMsg = '';
    this.open(this.referFriendPopup);
    return false;
  }

  referFriend(fname, frndName, email) {
    this.apiService.post(REFER_FRIEND, { fname: fname, frndName: frndName, email: email })
      .subscribe((result) => {
        if (result['status'] === 'success') {
          this.referFrndType = 'info';
          this.referFrndMsg = result['message'];
        } else {
          this.referFrndType = 'danger';
          this.referFrndMsg = result['error_info']['message'];
        }
      });
  }

  /**
   * To open Bootstrap modal window
   * @param content
   */
  open(content, className = '') {
    this.frmReferFriend = this.fb.group({
      fname: ['', [Validators.required]],
      frndName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.pattern(EMAIL)]],
    });
    if (className !== '') {
      this.popRef = this.modalService.open(content, { windowClass: className });

    } else {
      this.popRef = this.modalService.open(content);
    }
  }
  onRadioChangeEvent(e) {
    this.newUIToggel = e;
    this.dataservice.newUI(e);
    if (e === false) {
      this.dataservice.newUIClass('');
      document.body.classList.remove('new-theme');
    } else {
      this.dataservice.newUI(true);
      this.dataservice.newUIClass('page-body');
      document.body.classList.add('new-theme');
    }
  }
  onv2click() {
    /*call api once session true
    ** then redirect to same domain with new view
    ** view will have hidden form which will submit to login controller
    */
    this.apiService.get(LOGIN_STATUS + "?page=" + this.router.parseUrl(this.router.url))
      .subscribe((result) => {
        if (result) {
          console.log(`${environment.api_url}`);
          console.log(`${REDIRECT_NEWUI}`);
          // window.open(
          //     `${environment.api_url}${REDIRECT_NEWUI}`,
          //     '_blank' //  This is what makes it open in a new window.
          // );
          window.location.href = `${environment.api_url}${REDIRECT_NEWUI}`;
        }
      });

  }

  openAccountList() {
    this.subaccountUsername = '';
    this.isDisabled = true;
    this.fetchSubAccountList();
    this.modalService.open(this.accountListSection, { windowClass: 'right-side-modal', backdrop: 'static' });
    return true;
  }

  onChangeUsername(accountName) {
    this.subaccountUsername = accountName;
    this.isDisabled = !accountName;
  }

  redirectToAccount(accountName) {
    console.log("Redirect to " + accountName)
    this.apiService.post(SUBACCOUNT_SWITCH, { 'username': accountName })
      .subscribe(result => {
        if (result['status'] === 'success') {
          window.location.href = `${environment.api_url}login/redirectToSubaccount`;
        } else {
          console.log("RESULT EMPTY");
        }
      },
      );
  }

  fetchSubAccountList() {
    this.apiService.get(SUB_ACCOUNT_LIST)
      .subscribe((result) => {
        if (result['status'] == 'success') {
          this.subAccountList = result.data.subaccount.data;
        }
      });
  }

  isSwitchAccount() {
    this.apiService.get(SWITCH_ACCOUNT)
      .subscribe((result) => {
        if (result['switch_account'] == 1) {
          this.switchAccount = true;
        }
      });
  }
  verifyAccount() {
    this.showEmail = false;
    this.updateEmailFrm.reset();
    this.open(this.verifyAccountPopup, 'right-side-modal right-side-drawer-550px');
    return false;
  }

  fetchMMLiteStatus() {
    const url = 'setting/check_mmlite';
    this.subs.sink = this.apiService.whatapp_get(url).subscribe(res => {
      this.globals.shouldFetchMMLiteStatus = false;
      if (res.status !== 'success') {
        this.globals.is_mmlite_enabled = false;
        return;
      }
      this.globals.is_mmlite_enabled = res.data.is_mmlite_enabled;
    });
  }

  openDetails(): void {
    if (!this.bannerData) {
      return;
    }
    const data: ChannelRateLimitBannerDetailsDialogData = {
      channel: this.channel as 'rcs' | 'whatsapp',
      data: this.bannerData,
    };
    this.dialog.open(ChannelRateLimitBannerDetailsDialogComponent, {
      width: '440px',
      maxWidth: '95vw',
      autoFocus: false,
      panelClass: 'channel-rate-limit-details-pane',
      data,
    });
  }
}
